import React, { useEffect, useState } from 'react'
import { Button, Form, Input, message, Modal } from 'antd'
import validator from '../../validator'
import { KPI_TYPE } from '../../constants'
import { PlusOutlined } from '@ant-design/icons'
import kpiStore from '../../stores/kpiStore'
import { toJS } from 'mobx'

//Thêm chỉ tiêu
const SubTargetCreateModal = props => {
  const {
    isVisibleSubTargetCreateModal,
    handleCloseSubTargetCreateModal,
  } = props

  const [isLoading, setIsLoading] = useState(false)

  const [form] = Form.useForm()

  useEffect(() => {
    console.log('targetKpiDetail', toJS(kpiStore.targetKpiDetail))
  }, [kpiStore.targetKpiDetail])

  const onFinish = async values => {
    setIsLoading(true)

    const { sub_target_name } = values

    await kpiStore.createKpi(
      sub_target_name,
      KPI_TYPE.SUB_TARGET,
      kpiStore.targetKpiDetail.code,
      null
    )

    kpiStore.getTargetKpiDetail(kpiStore.targetKpiDetail.code)

    closeAndResetForm()

    setIsLoading(false)

    message.success('Tạo chỉ tiêu thành công')
  }

  const closeAndResetForm = () => {
    form.resetFields()
    handleCloseSubTargetCreateModal()
  }

  return (
    <Modal
      title="Thêm mới chỉ tiêu"
      footer={null}
      closable={true}
      visible={isVisibleSubTargetCreateModal}
      onCancel={closeAndResetForm}>
      <Form form={form} layout={'vertical'} onFinish={onFinish}>
        <Form.Item
          name={'sub_target_name'}
          rules={[
            { required: true, message: 'Vui lòng nhập tên chỉ tiêu!' },
            { validator: validator.validateInputString },
          ]}
          label={'Tên chỉ tiêu:'}>
          <Input placeholder={'Nhập tên chỉ tiêu'} />
        </Form.Item>

        <Form.Item>
          <Button
            icon={<PlusOutlined />}
            loading={isLoading}
            htmlType={'submit'}
            type={'primary'}>
            Tạo
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

SubTargetCreateModal.propTypes = {}

export default SubTargetCreateModal
